module.exports = __webpack_public_path__ + "img/arrowRight-disable.0da86002.svg";